import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Form, Input, Button, Col, Row, Spin, Modal } from "antd";
import {
  UserOutlined,
  LockOutlined,
  EyeTwoTone,
  EyeInvisibleOutlined,
  MailOutlined,
} from "@ant-design/icons";
import "./login.less";
import api from "../../api";
import { LOGIN } from "../../api/login";
import cookie from "react-cookies";
import uitls from "../../assets/js/public";
import { message } from "antd";

import { useTranslation } from "react-i18next";

import Header from "./header";
import Footer from "./footer";
import Cover from "./cover";

const Login = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = t("WEBTitle");

    if (!!cookie.load("accessToken")) {
      history.push("/index/task/create");
    }
  }, []);

  const login = async (values) => {
    setLoading(true);
    values = Object.assign(values);
    let res = await LOGIN(values);
    console.log(res);
    // console.log(data);
    if (res.data.code === 200) {
      message.success(t("pages.login.msg1"));
      cookie.save("accessToken", res.data.data?.token);
      localStorage.setItem("userInfo", JSON.stringify(res.data.data));
      history.push("/index/task/create");
      return;
    } else {
      message.error(
        t("pages.login.msg3") 
      );
    }

    // message.error(res.Message);
    setLoading(false);

    // // test
    //   message.success(t("pages.login.msg1"));
    //   history.push("/index/overview");
    //   return;
  };

  return (
    <div className="cont">
      <Header />
      <div className="login-cont">
        <Cover />
        <div className="login-sign">
          <Form
            className="login-form"
            onFinish={login}
            name="login"
            initialValues={{ remember: true }}
            layout="vertical"
          >
            <Form.Item
              label={t("pages.login.label1")}
              name="email"
              rules={[
                { required: true, message: t("pages.login.label1Placeholder") },
              ]}
            >
              <Input
                size="large"
                allowClear
                prefix={
                  <MailOutlined
                    style={{
                      color: "rgba(0,0,0,.25)",
                      fontSize: "18px",
                    }}
                  />
                }
                placeholder={t("pages.login.label1Placeholder")}
              />
            </Form.Item>
            <Form.Item
              label={t("pages.login.label2")}
              name="password"
              rules={[
                { required: true, message: t("pages.login.label2Placeholder") },
              ]}
            >
              <Input.Password
                size="large"
                allowClear
                prefix={
                  <LockOutlined
                    style={{
                      color: "rgba(0,0,0,.25)",
                      fontSize: "18px",
                    }}
                  />
                }
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
                placeholder={t("pages.login.label2Placeholder")}
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                size="large"
                style={{ fontSize: "14px", borderRadius: "5px" }}
                block
              >
                {t("pages.login.subBtn")}
              </Button>
              <div
                className="after d-flex justify-content-between"
                style={{ color: "rgba(0, 0, 0, 0.45)", marginTop: "15px" }}
              >
                <Link to="/forget">{t("pages.login.btn1")}</Link>
                <Link to="/register">{t("pages.login.btn2")}</Link>
              </div>
            </Form.Item>
          </Form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Login;
